import React from 'react';
import Select , { components } from 'react-select';
import { FaChevronDown } from 'react-icons/fa';
import styled from 'styled-components';

const ReactSelect = ({ ...rest }) => {
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <ChevronDown />
      </components.DropdownIndicator>
    );
  };

  return <StyledSelect components={{ DropdownIndicator }} {...rest} />;
};

const StyledSelect = styled(Select)`
  margin-bottom: 2rem;

  > div {
    border-color: ${({ theme }) => theme.palette.grayscale[6]};
    border-radius: 0;
    background-color: ${({ theme }) => theme.palette.grayscale[8]};

    [class*='ValueContainer'] {
      position: unset;
    }

    [class*='IndicatorsContainer'] {
      height: 2rem;
      > span {
        background-color: ${({ theme }) => theme.palette.grayscale[8]};
      }
    }
  }
`;

const ChevronDown = styled(FaChevronDown)`
  color: ${({ theme }) => theme.palette.grayscale[2]};
  font-size: 1.2rem;
`;

export default ReactSelect;
